import React from "react";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Carousel.css";

const Carousel1 = () => {
  const PHONE = "+919318333680";

  return (
    <section className="rk-premium-carousel">
      <Carousel
        fade
        interval={4500}
        pause="hover"
        className="rk-custom-carousel"
        indicators={true}
      >

        {/* =====================================================
            SLIDE 1
        ===================================================== */}
        <Carousel.Item>
          <div className="rk-carousel-slide">

            <img
              src={`${process.env.PUBLIC_URL}/img/slider3.jpeg`}
              className="rk-carousel-image"
              alt="RK Sofa Works Sofa Restoration"
            />

            <div className="rk-carousel-overlay"></div>

            <div className="rk-carousel-caption">

              <div className="rk-caption-topline">
                <span></span>
                <small>RK SOFA WORKS</small>
              </div>

              <span className="rk-caption-number">
                01 / 02
              </span>

              <h1>
                Bring Your
                <br />
                Sofa Back
                <br />
                <em>to Life.</em>
              </h1>

              <p>
                Thoughtful sofa repair and restoration that
                brings back comfort, character and a fresh
                new finish to your furniture.
              </p>

              <div className="rk-caption-buttons">

                <a
                  href={`tel:${PHONE}`}
                  className="rk-carousel-primary"
                >
                  <i className="fa-solid fa-phone"></i>
                  <span>Talk to Us</span>
                </a>

                <Link
                  to="/sofa_repair"
                  className="rk-carousel-secondary"
                >
                  <span>View Services</span>
                  <i className="fa-solid fa-arrow-right"></i>
                </Link>

              </div>

            </div>

            <div className="rk-carousel-side-label">
              <span>REPAIR</span>
              <span>RESTORE</span>
              <span>REFRESH</span>
            </div>

          </div>
        </Carousel.Item>


        {/* =====================================================
            SLIDE 2
        ===================================================== */}
        <Carousel.Item>
          <div className="rk-carousel-slide">

            <img
              src={`${process.env.PUBLIC_URL}/img/slider1.jpeg`}
              className="rk-carousel-image"
              alt="RK Sofa Works Upholstery Service"
            />

            <div className="rk-carousel-overlay"></div>

            <div className="rk-carousel-caption">

              <div className="rk-caption-topline">
                <span></span>
                <small>CRAFTED FOR YOUR HOME</small>
              </div>

              <span className="rk-caption-number">
                02 / 02
              </span>

              <h1>
                Comfort
                <br />
                Deserves a
                <br />
                <em>Second Life.</em>
              </h1>

              <p>
                From worn upholstery to tired cushions, our
                craftsmen carefully rebuild the details that
                make your sofa feel like home again.
              </p>

              <div className="rk-caption-buttons">

                <Link
                  to="/about"
                  className="rk-carousel-primary"
                >
                  <span>Discover RK</span>
                  <i className="fa-solid fa-arrow-right"></i>
                </Link>

                <a
                  href={`tel:${PHONE}`}
                  className="rk-carousel-secondary"
                >
                  <i className="fa-solid fa-phone"></i>
                  <span>Call Now</span>
                </a>

              </div>

            </div>

            <div className="rk-carousel-side-label">
              <span>UPHOLSTERY</span>
              <span>CUSHIONS</span>
              <span>CRAFTSMANSHIP</span>
            </div>

          </div>
        </Carousel.Item>

      </Carousel>
    </section>
  );
};

export default Carousel1;